import React, { useEffect } from 'react';
import { SttTabs } from '@stt-componentes/core-v2';
import { TIPO_ABA_EXAME, VINCULO_PERFIL } from '../../componentes/exame/constantes';
import { MODALIDADE, PERMISSOES } from '../../common/Constants';
import { temPermissaoRede } from '../../security/acl';
import { useSignal, useSignals } from '@preact/signals-react/runtime';
import Aba from '../../componentes/laudo/fabrica';
import usuario from '../../signals/usuario';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        padding: theme.spacing(2)
    }
}));

const Laudo = () => {
    useSignals();

    const abas = useSignal([]);

    const classes = useStyles();

    useEffect(() => {
        if (usuario.value.perfisRBAC) {
            let dadosAbas = [];
            usuario.value.perfisRBAC.forEach(perfil => {
                if (perfil.vinculo === VINCULO_PERFIL.REDE) {
                    perfil.redes.forEach(rede => {
                        if (temPermissaoRede(rede, PERMISSOES.LAUDAR_EXAME_FABRICA)) {
                            const redeJaAdd = dadosAbas.some(d => (d.id === rede.id && d.tipo === TIPO_ABA_EXAME.REDE));
                            if (!redeJaAdd && usuario.value.modalidadesRede?.some(modalidade => modalidade.sigla_modalidade === MODALIDADE.SIGLA && modalidade.id_rede_telemedicina === rede.id)) {
                                dadosAbas.push({
                                    id: rede.id,
                                    tipo: TIPO_ABA_EXAME.REDE,
                                    titulo: rede.descricao,
                                    conteudo: Aba,
                                });
                            }
                        }
                    });
                }

            });

            abas.value = dadosAbas;
        }
    }, [])

    return (
        <SttTabs
            abas={abas.value}
            className={classes.wrapper}
        />
    );

}

export default Laudo;